var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 23.6125H8.01776L19.6599 11.9704L17.8921 10.2026L6.25 21.8448V23.6125ZM26.25 26.1125H3.75V20.8093L20.5437 4.01541C21.032 3.52725 21.8234 3.52725 22.3115 4.01541L25.8471 7.55094C26.3353 8.0391 26.3353 8.83055 25.8471 9.31871L11.5533 23.6125H26.25V26.1125ZM19.6599 8.43483L21.4276 10.2026L23.1954 8.43483L21.4276 6.66706L19.6599 8.43483Z",
    fill: "#4E7FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.b89698e12e4611e547815ddf660622a3.svg";
export { ForwardRef as ReactComponent };